module.exports = __webpack_public_path__ + "img/gm.e00cacd6.svg";